import {computed, makeObservable} from "mobx";
import SaporeForm from "../SaporeForm";
import TextField from "./TextField";
import MultipleOptionsField from "./MultipleOptionField";

export default class UserForm extends SaporeForm {
    static newEmpty(feature = null, configuration) {
        const initialData = {
            id: null,
            email: '',
            roles: [],
            deliverySiteOnboardingRequests: []
        };
        return this.newFor(initialData, feature, configuration);
    }

    static newFor(userData, feature = null, configuration) {
        return new UserForm(userData, feature, userData.id, configuration);
    }

    constructor(initialData = {}, feature = null, id = null, configuration) {
        const deliverySiteOnboardingRequestsIds = initialData.deliverySiteOnboardingRequests.map(deliverySiteOnboardingRequest => deliverySiteOnboardingRequest.id);
        const fields = {
            email: new TextField(5, 100, false, initialData.email, feature),
            roles: new MultipleOptionsField(feature.rolesFieldOptions(), false, feature, initialData.roles),
            deliverySiteOnboardingRequests: new MultipleOptionsField(feature.deliverySitesFieldOptions(), false, feature, deliverySiteOnboardingRequestsIds)
        };

        super(fields, id, feature, configuration);

        makeObservable(this, {
            emailValue: computed,
            rolesValue: computed,
            deliverySiteOnboardingRequestsValue: computed,
        });
    }

    formEntity() {
        return {...this.values, id: this.entityId()}
    }

    email() {
        return this.emailField().value;
    }

    roles() {
        return this.rolesField().value;
    }

    deliverySiteOnboardingRequests() {
        return this.deliverySiteOnboardingRequestsField().value;
    }

    emailField() {
        return this.getFieldByName('email');
    }

    rolesField() {
        return this.getFieldByName('roles');
    }

    deliverySiteOnboardingRequestsField() {
        return this.getFieldByName('deliverySiteOnboardingRequests');
    }

    get emailValue() {
        return this.email();
    }

    get rolesValue() {
        return this.roles();
    }

    get deliverySiteOnboardingRequestsValue() {
        return this.deliverySiteOnboardingRequests();
    }

    isReadonly(fieldName) {
        return !this._feature.canEditUserOnboardingRequests();
    }
}
